import { Tooltip } from '@meitu/saas-ui';
import IconFont from '@meitu/xdesign-icon-font';
import { useLocaleStore } from '@/i18n';
import type { IStageToolbarItemRenderArgs } from '../../types';
import { useScaleController } from '../scale/use-scale-controller';

const FitViewportItem = ({ toolbar }: Pick<IStageToolbarItemRenderArgs, 'toolbar'>) => {
    const { $t } = useLocaleStore();
    const { fitViewport } = useScaleController(toolbar);

    return (
        <Tooltip placement="top" title={$t((value) => value.Tooltip_ShowAll)} trigger="hover">
            <button type="button" className="stage-toolbar-fit-viewport" onClick={fitViewport}>
                <IconFont name="AimBold" fontSize={16} />
            </button>
        </Tooltip>
    );
};

export const fitViewportItemRender = ({ config, toolbar }: IStageToolbarItemRenderArgs) => {
    if (!config.items.fitViewport || !toolbar.getItemAvailability('fit-viewport')) return null;
    return <FitViewportItem toolbar={toolbar} />;
};
